module.exports = __webpack_public_path__ + "img/pic.d563bc81.png";